<template>

  <div class="bureau">
    <a target="_blank" :href="item.comite_directeur">
      <pdf ref="pdf" :src="item.comite_directeur" :resize="true" :text="false">
        <template slot="loading">
        </template>
      </pdf>
    </a>

    <a target="_blank" :href="item.organigramme_technique">
      <pdf ref="pdf" :src="item.organigramme_technique" :resize="true" :text="false">
        <template slot="loading">
        </template>
      </pdf>
    </a>
  </div>

</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Bureau',
    components: {
      pdf
    },
    data() {
      return {
        item: {
          comite_directeur: "https://www.asspm.fr/rubriques/comite_directeur.pdf"
          , organigramme_technique: "https://www.asspm.fr/rubriques/organigramme_technique.pdf"
        }
      }
    }
  }

</script>